// extracted by mini-css-extract-plugin
export default {"titleContainer":"styles_titleContainer__-fxMf","title":"styles_title__mpeA4","subtitle":"styles_subtitle__qUB-n"};